var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"add-one animate__animated animate__backInUp"},[_vm._v("+"+_vm._s(_vm.addnumber))])
}
var staticRenderFns = []

export { render, staticRenderFns }